export const cleanObject = <T extends Record<string, unknown>>(
  obj?: T,
): Partial<T> | undefined => {
  if (!obj) return undefined;

  const result = Object.fromEntries(
    Object.entries(obj).filter(
      ([, v]) => v !== undefined && v !== null && v !== '',
    ),
  ) as Partial<T>;

  return Object.keys(result).length ? result : undefined;
};
